import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

interface ModalComponentProps {
  children: any;
  show: boolean;
  setOpen: (arg: boolean) => void;
  title: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  centered?: boolean;
}

const ModalComponent = ({ show, setOpen, title, size = 'md', centered = true, children }: ModalComponentProps) => {
  const toggle = () => setOpen(!show);

  return (
      <Modal
          isOpen={show}
          toggle={toggle}
          size={size}
          centered={centered}
      >
        <ModalHeader toggle={toggle}>
          {title}
        </ModalHeader>

        <ModalBody>
          {children}
        </ModalBody>
      </Modal>
  );
};

export default ModalComponent
